
import {defineComponent, PropType} from 'vue'
import FileUpload from "primevue/fileupload";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InfoButton from "@/components/legend/InfoButton.vue";

export type customImage = {
  fileName: string,
  fileType: string,
  userComment: string | null,
  imageText: string | null,
  imageBlob: string | null | ArrayBuffer,
  recordId: number | any
}

export default defineComponent({
  name: "ImagePicker",
  components: {
    Button, FileUpload, InputText, InfoButton
  },
  data() {
    return {
      error: false as boolean,
      images: [] as customImage[],
    }
  },
  props: {
    name: {type: String, required: true},
    value: {type: Array as PropType<customImage[]>, default: () => []},
  },
  methods: {
    select(event: any, key: number) {
      let files: FileList = event.files
      for (let i = 0; i < files.length; i++) {
        console.log("files[i] ", files[i])
        let reader = new FileReader()
        const item = files[i]!
        reader.onloadend = () => {
          // this.images = this.images.filter((ci: customImage) => ci.fileName !== item.name) // Overwrite existing
          this.images[key].imageBlob = reader.result
          this.images[key].fileName = item.name
          this.images[key].fileType = item.type

        }
        reader.readAsDataURL(item)
      }
    },
    remove(idx: number) {
      // this.images = this.images.filter((ci: customImage) => ci.fileName !== image.fileName)
      this.images.splice(idx, 1)

    },
    add() {
      this.images.push(JSON.parse(JSON.stringify({
        imageBlob: '',
        fileName: '',
        fileType: ''
      } as customImage)))
    },
  },
  mounted() {
    this.images = this.value
  },
  watch: {
    images: {
      handler() {
        this.$emit('select', {key: this.name, value: this.images})
      },
      deep: true
    }
  }
})
